import { Routes, Route } from "react-router-dom";
import { Layout } from "./components/Layout";
import { Home } from "./pages/Home";
// import { Sefira } from "./pages/Sefira";

const navLinks = [
  { path: "/#home", label: "Home" },
  { path: "/#about", label: "About" },
  { path: "/#projects", label: "Projects" },
  { path: "/#contact", label: "Contact" },
  // { path: "/sefira", label: "Sefira" },
];

export function App() {
  return (
    <Layout navLinks={navLinks}>

      <Routes>
        <Route path="/" element={<Home navLinks={navLinks} />} />
        {/* <Route path="/sefira" element={<Sefira />} /> */}
      </Routes>
    </Layout>
  );
}

export default App;
